<app-modal title="Select a Vendor" [showCancel]="false" okText="Close">
	<div class="row vertical-center">
		<mat-form-field class="col-xs-6" appearance="outline">
			<mat-label>Search</mat-label>
			<input matInput [(ngModel)]="searchInput" placeholder="Search" (input)="vendorSearch()">
			<mat-icon aria-hidden="false" aria-label="Search" matSuffix>search</mat-icon>
		</mat-form-field>
		<mat-form-field class="col-xs-6" appearance="outline">
			<mat-label>Status</mat-label>
			<mat-select [(ngModel)]="vendorStatusValue" (selectionChange)="vendorStatus()">
				<mat-option [value]="0">All Vendors</mat-option>
				<mat-option [value]="1">Active Vendors</mat-option>
				<mat-option [value]="2">Inactive Vendors</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<div class="mat-elevation-z8">
		<table class="w-100" mat-table [dataSource]="dataSource" matSort aria-label="List">
			<ng-container matColumnDef="ShortName">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Vendor Code </th>
				<td mat-cell *matCellDef="let row"> {{row.ShortName}} </td>
			</ng-container>
			<ng-container matColumnDef="VendorName">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Vendor Name </th>
				<td mat-cell *matCellDef="let row"> {{row.VendorName}} </td>
			</ng-container>
			<ng-container matColumnDef="ParentVendor">
				<th mat-header-cell *matHeaderCellDef mat-sort-header> Parent Vendor </th>
				<td mat-cell *matCellDef="let row"> {{row.ParentVendorShortName}} - {{row.ParentVendorName}} </td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row (click)="clickRow(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell" colspan="4">No Vendors Found</td>
			</tr>
		</table>
		<mat-paginator [pageSizeOptions]="[12]" [length]="dataSourceLength"></mat-paginator>
	</div>
</app-modal>